import { render, staticRenderFns } from "./PastDiagnosisInfo.vue?vue&type=template&id=52441687"
import script from "./PastDiagnosisInfo.vue?vue&type=script&lang=js"
export * from "./PastDiagnosisInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports